import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import useInterval from 'use-interval';
import { Table, Button, message, Tooltip, } from 'antd';
import { PlayCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useI18n, useSession } from 'applib-frontend';
import dayjs from 'dayjs';
// eslint-disable-next-line import/no-unresolved
import { json } from '@newtontechnologies/beey-api-js-client/receivers';
import TableStatus from '../TableStatus';
import TableAddTime from '../TableAddTime';
import TableSubtractTime from '../TableSubtractTime';
import TableLink from '../TableLink';
import './style.less';
const isStreamTVR = window.location.href.includes('streamtvr');
const StreamTable = ({ onProjectId, onShowVideo, captionsLoaded }) => {
    const { connection } = useSession();
    const [selectedTasks, setSelectedTasks] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [windowSize, setWindowSize] = useState(window.innerWidth);
    const { intl } = useI18n();
    const checkSize = () => {
        setWindowSize(window.innerWidth);
    };
    useEffect(() => {
        window.addEventListener('resize', checkSize);
        return () => window.removeEventListener('resize', checkSize);
    });
    const changeTime = async (add, taskID) => {
        await connection.fetch()
            .url(`api/stream2beey/Change?add=${add}&taskID=${taskID}`)
            .receive(json())
            .send();
    };
    const streamColumnTitle = (_jsxs(_Fragment, { children: [intl.formatMessage({ id: 'liveCaptions' }), _jsx(Tooltip, { title: intl.formatMessage({ id: 'streamAvailable' }), children: _jsx(InfoCircleOutlined, { className: "infoIcon" }) })] }));
    const columns = [
        {
            title: intl.formatMessage({ id: 'title' }),
            dataIndex: 'title',
            key: 'name',
            width: '23%',
            render: (text, record) => (_jsx(TableLink, { text: text, state: record.state, projectId: record.projectId, url: record.beeyUrl })),
        },
        {
            title: 'Status',
            dataIndex: 'progress',
            key: 'progress',
            width: '20%',
            render: (text, record) => (_jsx(TableStatus, { text: text, progress: record.progress, state: record.state, percentage: record.percentage, url: record.beeyUrl })),
        },
        {
            title: intl.formatMessage({ id: 'startTime' }),
            dataIndex: 'date',
            key: 'date',
            width: '23%',
            render: (text) => dayjs(text).format('DD.MM.  YYYY HH:mm'),
        },
        {
            title: intl.formatMessage({ id: 'length' }),
            dataIndex: 'length',
            key: 'length',
            width: '23%',
            render: (text, record) => {
                if (windowSize < 767) {
                    return (_jsxs(_Fragment, { children: [_jsx("span", { children: text }), _jsxs("div", { className: "length", children: [_jsx(TableSubtractTime, { state: record.state, length: record.length, id: record.id, onSubtractTime: (add, id) => changeTime(add, id) }), _jsx(TableAddTime, { state: record.state, id: record.id, onAddTime: (add, id) => changeTime(add, id) })] })] }));
                }
                return (_jsxs("div", { className: "length", children: [_jsx("div", { children: _jsx(TableSubtractTime, { state: record.state, length: record.length, id: record.id, onSubtractTime: (add, id) => changeTime(add, id) }) }), _jsx("span", { children: text }), _jsx("div", { children: _jsx(TableAddTime, { state: record.state, id: record.id, onAddTime: (add, id) => changeTime(add, id) }) })] }));
            },
        },
    ];
    const columnWithLiveCaptions = [
        ...columns.slice(0, 1),
        {
            title: streamColumnTitle,
            width: isStreamTVR ? '20%' : '0%',
            render: (record) => {
                if ((record.projectId === taskList[0].projectId && captionsLoaded && isStreamTVR)) {
                    return (
                    // eslint-disable-next-line jsx-a11y/control-has-associated-label
                    _jsx("button", { type: "button", onClick: () => onShowVideo(true), className: "showVideo-button", children: _jsx(PlayCircleOutlined, { style: { fontSize: '30px', color: 'grey' } }) }));
                }
                return null;
            },
        },
        ...columns.slice(1),
    ];
    const fetchTasks = async () => {
        const list = await connection.fetch()
            .receive(json())
            .url('api/tasks/stream2beey/status')
            .fetch();
        setTaskList(list);
        onProjectId(list.length > 0 ? list[0].projectId : 0);
    };
    useInterval(() => fetchTasks(), 1000);
    const selectRows = (rows) => {
        const stringArray = rows.map((row) => String(row.id));
        setSelectedTasks(stringArray);
    };
    const rowSelection = {
        onChange: (_, selectedRows) => {
            selectRows(selectedRows);
        },
    };
    const handleDeleteSelected = async () => {
        if (selectedTasks.length === 0) {
            void message.warning(intl.formatMessage({ id: 'selectAtLeastOne' }), 2);
        }
        else {
            await connection.fetch()
                .post()
                .url(`api/tasks/stream2beey/Remove?tasks=${selectedTasks.join(',')}`)
                .send();
            onShowVideo(!selectedTasks.includes(taskList[0].id.toString()));
        }
    };
    return (_jsxs("div", { className: "table", children: [_jsx(Table, { dataSource: taskList, columns: isStreamTVR ? columnWithLiveCaptions : columns, rowKey: (record) => record.id, rowSelection: rowSelection, pagination: { pageSize: 5 } }), _jsx(Button, { onClick: () => handleDeleteSelected(), children: intl.formatMessage({ id: 'deleteSelected' }) })] }));
};
export default StreamTable;
